import {VerticalLineIcon} from '@time-webkit/all/icons/vertical-line';

import styles from './divider.module.css';

export const Divider = () => (
    <div className={styles.divider}>
        <VerticalLineIcon />
    </div>
);
